import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getHealthProductStart,
  getHealthProductSuccess,
  getHealthProductFailure,
} from "../reducers/getHealthProductReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getHealthProduct = createAsyncThunk(
  "getHealthProduct",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getHealthProductStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Health/GetProduct`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getHealthProductSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getHealthProductFailure(error.response.data.Message));

      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
        await thunkAPI.dispatch(getHealthProduct());
      }
      throw error;
    }
  }
);
